export const visitorApi = {
  DELETE_VISITOR_EVENT: '/api/fair/event/get/all/join-event',
  GET_VISITOR_EVENT: `/api/fair/event/get/all/join-event/all`,
  GET_VISITOR_PROFILE_DATA: '/api/auth/visitor/profile',
  VISITOR_PROFILE_DATA_UPDATE: '/api/auth/visitor/profile',

  /* ticketing request------------------------ */
  TICKETING_SERVICE_LIST: '/api/visitor/ticket/service-list',
  CREATE_TICKETING_REQUEST: '/api/visitor/ticket',
  GET_ALL_TICKETING_REQUEST: '/api/visitor/ticket',
  DELETE_TICKETING_REQUEST: '/api/visitor/ticket',

  /* INVOICE----------------- */
  GET_VISITOR_INVOICE: '/api/visitor/payment',
};
